import React from "react";
import { Link } from "react-router-dom";
import { BiDonateHeart } from "react-icons/bi";
import { FaPeopleCarry } from "react-icons/fa";

export default class PartnerShipCta extends React.Component {
  render() {
    return (
      <>
        <section
          className="cta-one"
          style={{
            padding: "40px 0",
            background: "rgba(var(--sopot-black-rgb), .99)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="cta-one__inner">
                  <div className="cta-one__left">
                    <div className="cta-one__icon">
                      <FaPeopleCarry fontSize={"48px"} />
                    </div>
                    <h2 className="cta-one__title">
                      Want to partner <br /> with Us ?
                    </h2>
                  </div>
                  <div className="cta-one__right">
                    <Link
                      to={process.env.PUBLIC_URL + `/contact`}
                      className="thm-btn cta-one__btn border"
                    >
                      Be A Partner
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
